import { fetchAPI } from "./baseApi";

export async function getWebinarsAdmin() {
  return fetchAPI("/webinars/admin", { method: "GET" });
}

export async function createWebinar(data) {
  return fetchAPI("/webinars/admin", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateWebinar(id, data) {
  return fetchAPI(`/webinars/admin/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteWebinar(id) {
  return fetchAPI(`/webinars/admin/${id}`, { method: "DELETE" });
}
